/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row  , Modal , Button} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import assignmentServices from '../../services/assignments-service.js';
import Recorder from '../feedbackRecorderUploader.js'
import Config from '../../classes/config.js';
import CatalogService from '../../services/content-service.js';
import Translation from '../../store/internationalization-store.js';
import jsPDF from 'jspdf';

export default class ExamTestGradeContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {saveButtonPressed:false};
    }

    componentWillReceiveProps(props) {
        if (this.refs.sourcedAudio != undefined) {
            this.refs.sourcedAudio.load();
        }
        this.supportDataUrl = undefined;
        this.props = props;
        if (this.props.gradeData == undefined || this.props.gradeData.uid == undefined || 
                this.props.gradeData.game_uid == undefined || this.props.gradeData.exam_uid == undefined) {
            return;
        }

        var toIetf = 'en'
        if (this.props.gradeData.game_uid == "216" || this.props.gradeData.game_uid == "215" || this.props.gradeData.game_uid == "214") {
            toIetf = "EXTRA";
        }

        if(this.props.show){
            CatalogService.getExamDataQuestion(this.props.gradeData.game_uid, this.props.gradeData.exam_uid, toIetf, "en").then(function(response){
                this.setState({loading:false,
                    uid:this.props.gradeData.uid,
                    examQuestion:response,
                    grade:this.props.gradeData.percentage,
                    comment:this.props.gradeData.comment,
                    audio: this.props.gradeData.audio,
                    file: this.props.gradeData.file,
                    text: this.props.gradeData.text,
                    game_uid:this.props.gradeData.game_uid,
                    hasChanged:false,
                    saveButtonPressed:false
                })
            }.bind(this));
        }
        
    }

    saveFeedback() {
        if ( this.state.saveButtonPressed == true) {
            return;
        }
        this.state.saveButtonPressed = true;
        var supportData = this.supportDataUrl;
        var keys  = {};
        keys['game_data_uid'] = this.state.uid;

        var grade = undefined;
        var writtenFeedback = "";
        if (this.state.grade != "") {
            grade = this.state.grade;
        }
        if (this.state.writtenFeedback != "") {
            writtenFeedback = this.state.writtenFeedback;
        }
        assignmentServices.gradeQuestionExamTest(grade, keys, writtenFeedback, supportData).then(function(){
            if(this.props.onSave) {
                this.props.onSave();
            }
        }.bind(this))
        this.state.grade = "";
        
    }

    onHide() {
        this.setState({examQuestion:undefined});
        this.props.onHide();
    }

    downloadText(name, value,questionName,due,text)
    {
        var pdf   = new jsPDF();
        pdf.setFontSize(16);
        pdf.setTextColor(33, 20, 60);
        var studentName = String(name);
        //var module = this.state.allHeaders[jdx];
        pdf.text(10, 20, Translation.get(14 , 'Name') +": "+ studentName);
        pdf.text(10, 28, Translation.get(12211 , 'Grade') +": "+ value || '0%');
        pdf.text(10, 36, Translation.get(12151 , 'Question') +": "+ String(questionName));
        pdf.text(10, 44, Translation.get(484 , 'Due') +": "+ due);


        var splitTitle = pdf.splitTextToSize(String(text).replace(/(?:\r\n|\r|\n)/g, '\n\n'), 180);

        for(var idx =0; idx < splitTitle.length; idx++)
        {
            var text = splitTitle[idx];
            pdf.text(10, 55 + idx*10, text);
        }
                   //   pdf.text(10, 60, splitTitle);
        pdf.save(String(name)+' '+due+'.pdf');
    }

    render() {
        if (this.state.examQuestion == undefined) {
            return "";
        }
        var header = "";
        var name = "";
        var imageData = "";
        var audioData = "";
        var userDataFinal = "";
        var examText = "";
        var examDataText = "";
        if (this.refs.sourcedAudio != undefined) {
            this.refs.sourcedAudio.load();
        }
        if (this.state.file != "" && this.state.file != undefined && this.state.file != null) {
            userDataFinal = <div><b >{Translation.get(12659 , "Student's Answer")}:</b>
                <br/>
                <audio ref="sourcedAudio" style={{width:'100%' , marginTop:'10px'}} controls>
                    <source src={Config.getFeedbackBaseUrl()+this.state.file} />
                    Your browser does not support the video tag.</audio></div>
        } else {
            var textRaw = ""
            try /// MISSING DATA IN THE DATABASE I THINK THIS IS A CATCH SO PAUL CAN REVIEW
            {
                textRaw = this.state.text.replace(this.state.examQuestion.examData.text, "");
            }
            catch(e)
            {
                textRaw = ''
            }
            var name = "";
            userDataFinal =<div><b>{Translation.get(12659 , "Student's Answer")}:</b><div class="scroll" style={{maxHeight:"200px"}}>
                {textRaw}
            </div></div>
        }
        if ((this.state.game_uid == "208" || this.state.game_uid == "214" || this.state.game_uid == "217") &&
            this.state.examQuestion.examData.image != "" && this.state.examQuestion.examData.image != undefined
            && this.state.examQuestion.examData.image != null) {
            imageData = <center><img src={Config.getBaseUrl()+"vocabs/"+
                    this.state.examQuestion.examData.image} alt="logo"  style={{maxWidth:"60%"}}/></center>
        }

        if (this.state.game_uid == "215") {
            examText = <div>{this.state.examQuestion.examData.text_extra}</div>
        }

        if ((this.state.game_uid == "216") &&
            this.state.examQuestion.examData.writing_audio != "" && this.state.examQuestion.examData.writing_audio != undefined
            && this.state.examQuestion.examData.writing_audio != "null") {
                if (this.state.examQuestion.examData.writing_audio.indexOf(".mp4") > -1) {
                    audioData = <center><video width="320" height="200" controls>
                    <source src={Config.getBaseUrl()+this.state.examQuestion.examData.writing_audio} type="video/mp4"/>
                    Your browser does not support the video tag.
                    </video></center>
                } else {
                    audioData = <audio controls>
                    <source src={Config.getBaseUrl()+this.state.examQuestion.examData.writing_audio} type="video/mp4"/>
                    Your browser does not support the video tag.
                    </audio>
                }
        }
        if (!((this.state.game_uid == "208" || this.state.game_uid == "214" || this.state.game_uid == "217") &&
        this.state.examQuestion.examData.image != "" && this.state.examQuestion.examData.image != undefined
        && this.state.examQuestion.examData.image != null)) {
            examDataText = <h6><b>{this.state.examQuestion.examData.text}</b></h6>
        }
        var enterGrade = <Row  className="strong">
                <Col md={12}>
                    <FieldGroup id="grade" label={Translation.get(12660 , 'Grade by percentage %')}
                            value={this.state.grade} onChange={function(event){
                                if (isNaN(event.target.value) || event.target.value > 100){
                                    this.state.grade = this.state.grade; 
                                    this.setState({hasChanged:true , grade:this.state.grade});
                                    return;
                                } 
                                this.state.grade = event.target.value; 
                                this.setState({hasChanged:true , grade:event.target.value})}.bind(this)}
                            />
                </Col>
            </Row>
        header = <div>{examDataText}
                {examText}
                {imageData}
                {audioData}
                <br></br>
                <br></br>
                {userDataFinal}
                <hr/>
                {enterGrade}
                <hr/></div>
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {header}
                </Modal.Body>
                <Modal.Footer>
                     <Button onClick={this.onHide.bind(this)}>{Translation.get(41 , 'Cancel')}</Button> <Button disabled={!this.state.hasChanged} onClick={this.saveFeedback.bind(this)}>{Translation.get(657 , 'Save')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}